export default __webpack_public_path__ + "static/property-img-4_1400-480dba32c87ba1f23f558f27370a29af.jpg";